import { arrayItemsEqual } from '../utility';
var update = function (visibleItems, selectionData) {
    var trackBy = selectionData.trackBy, selectionType = selectionData.selectionType, keepSelection = selectionData.keepSelection, isItemDisabled = selectionData.isItemDisabled;
    var desiredSelectedItems = selectionData.selectedItems;
    if (selectionType !== 'multi') {
        desiredSelectedItems = desiredSelectedItems.slice(0, 1);
    }
    var newSelectedItems;
    if (keepSelection) {
        newSelectedItems = desiredSelectedItems;
    }
    else {
        newSelectedItems = getSelectedFromVisible(desiredSelectedItems, visibleItems, trackBy);
    }
    return {
        selectedItems: newSelectedItems,
        selectionType: selectionType,
        trackBy: trackBy,
        keepSelection: keepSelection,
        isItemDisabled: isItemDisabled
    };
};
var getSelectedFromVisible = function (desired, visible, trackBy) {
    if (trackBy) {
        // The following code iterates only once on the full list of items
        var selectedIds_1 = desired.map(function (item) { return item[trackBy]; });
        // reduce the list of items to the ones that are in the list of selected items
        var selectableItems_1 = visible.filter(function (item) { return selectedIds_1.indexOf(item[trackBy]) > -1; });
        // we iterate only on the smaller items
        return selectedIds_1.reduce(function (cumulated, id) {
            var found = selectableItems_1.filter(function (item) { return item[trackBy] === id; });
            if (found.length > 0) {
                cumulated.push(found[0]);
            }
            return cumulated;
        }, []);
    }
    return desired.filter(function (item) { return visible.indexOf(item) > -1; });
};
var compare = function (oldData, newData, userAction, desiredNewData) {
    // The following condition tests whether any desired selected item could not actually be selected
    // because it was not part of the visible items. In such cases we do not care if the change was triggered
    // by the user or by the component API, we have to fire the change event anyway
    if (!arrayItemsEqual(desiredNewData.selectedItems, newData.selectedItems, newData.trackBy)) {
        return true;
    }
    if (!userAction) {
        return false;
    }
    return (oldData.selectionType !== newData.selectionType ||
        !arrayItemsEqual(oldData.selectedItems, newData.selectedItems, newData.trackBy));
};
var defaultDisableFunction = function (item) { return false; };
export default {
    update: update,
    compare: compare,
    defaultDisableFunction: defaultDisableFunction
};
//# sourceMappingURL=utils.js.map